export interface IFaqGroupCheckbox {
    label: string;
    groupIndex: number;
    checked: boolean;
}


